import http from './http'

const LOCAL_SCALE_URL = process.env.VUE_APP_SCALE_URL || 'http://127.0.0.1:8787'

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

async function readLocalWeight() {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 8000)

  try {
    const res = await fetch(`${LOCAL_SCALE_URL}/weight`, {
      method: 'GET',
      signal: controller ? controller.signal : undefined,
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.message || 'Локальный агент весов недоступен')
    }
    const data = await res.json()
    if (!data || data.ok === false) {
      throw new Error((data && data.message) || 'Ошибка локальных весов')
    }
    return {
      value: Number(data.value),
      unit: data.unit || 'kg',
      stable: !!data.stable,
      source: 'local',
    }
  } finally {
    clearTimeout(timer)
  }
}

async function readRelayWeight() {
  const created = await http.post('scale/read').then((res) => res.data)
  const id = created.id
  if (!id) throw new Error('Не удалось создать запрос веса')

  for (let i = 0; i < 40; i += 1) {
    await sleep(300)
    const job = await http.get(`scale/read/${id}`).then((res) => res.data)
    if (job.status === 'ready' && job.result) {
      return {
        value: Number(job.result.value),
        unit: job.result.unit || 'kg',
        stable: !!job.result.stable,
        source: 'relay',
      }
    }
    if (job.status === 'failed') {
      throw new Error(job.message || 'Агент не смог считать вес')
    }
  }

  throw new Error('Таймаут ожидания веса. Запущен ли ves_agent?')
}

/**
 * Быстрый снимок локальных весов для индикатора (без relay).
 * Если агент не запущен — возвращает null.
 */
export async function peekLocalWeight() {
  const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
  const timer = setTimeout(() => {
    if (controller) controller.abort()
  }, 1500)

  try {
    const res = await fetch(`${LOCAL_SCALE_URL}/weight`, {
      method: 'GET',
      signal: controller ? controller.signal : undefined,
    })
    if (!res.ok) return null
    const data = await res.json()
    if (!data || data.ok === false) return null
    const value = Number(data.value)
    if (Number.isNaN(value)) return null
    return {
      value,
      unit: data.unit || 'kg',
      stable: !!data.stable,
      source: 'local',
      at: Date.now(),
    }
  } catch (error) {
    return null
  } finally {
    clearTimeout(timer)
  }
}

export async function readScaleWeight() {
  try {
    return await readLocalWeight()
  } catch (localError) {
    try {
      return await readRelayWeight()
    } catch (relayError) {
      const localMsg = localError && localError.message ? localError.message : 'local failed'
      const relayMsg = relayError && relayError.message ? relayError.message : 'relay failed'
      throw new Error(`${relayMsg} (local: ${localMsg})`)
    }
  }
}
